<template>
  <div ref="page" id="page" :class="['page' ,'index-page']">
    <div class="datepicker-content as-flex main-center cross-center">
      <div class="arrow last-week-arrow as-flex main-center cross-center" @click="changeweek(-1)">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="datepicker-container">
        <el-cascader
          class="datepicker"
          placeholder="请选择周期"
          :options="dateOptions"
          :show-all-levels="false"
          v-model="dateOptionsSelected"
          @change="handleDateChange"
        ></el-cascader>
      </div>
      <div class="arrow next-week-arrow as-flex main-center cross-center" @click="changeweek(1)">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="chart-content">
      <div class="top-function-bar as-flex main-between cross-center">
        <div class="left-title">
          <span class="f-4 fc-gray">调研数据</span>
          <span class="f-2 fc-gray-2">每周四更新</span>
        </div>
        <div class="right-function as-flex main-end cross-end">
          <div class="crowd-picker as-flex main-end cross-center">
            <crowdpicker
              :options="crowd_config"
              :current_crowd="current_crowd"
              @crowdUpdate="crowdUpdate"
            ></crowdpicker>
          </div>
          <div class="multi-compaire f-2 as-flex main-end cross-center">
            <span class="multi-compaire-btn" @click="multiCompaire">详细对比</span>
          </div>
        </div>
      </div>
      <div class="chart-container as-flex main-between cross-center">
        <div class="chart-box">
          <div class="chart-desc as-flex main-start cross-center">
            <span>认知度</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="在调研周期节点，'听说过'此影片的样本中对此影片类型感知的比例"
              placement="top-start"
            >
              <img
                tabindex="0"
                class="question-tip-icon icon-2"
                src="../assets/images/question@3x.png"
              >
            </el-tooltip>
            <span class="f-2 fc-gray-2">{{offsetMapping[latestOffset]}}</span>
          </div>
          <indexChart
            class="index-chart"
            indicator="awareness"
            :offset="latestOffset"
            :update_date="update_date"
            :config="chartData"
          ></indexChart>
        </div>
        <div class="chart-box">
          <div class="chart-desc as-flex main-start cross-center">
            <span>首选度</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="在调研周期节点，对此影片'非常感兴趣和比较感兴趣'的样本中'下次观影首先选择'此影片的比例。"
              placement="top-start"
            >
              <img
                tabindex="0"
                class="question-tip-icon icon-2"
                src="../assets/images/question@3x.png"
              >
            </el-tooltip>
            <span class="f-2 fc-gray-2">{{offsetMapping[latestOffset]}}</span>
          </div>
          <indexChart
            class="index-chart"
            indicator="primary"
            :offset="latestOffset"
            :update_date="update_date"
            :config="chartData"
          ></indexChart>
        </div>
      </div>
    </div>
    <div class="list-title as-flex main-start cross-center f-2 fc-gray-2">
      <div class="list-title-movie as-flex main-center cross-center">
        <span>影片</span>
      </div>
      <div class="list-title-awareness as-flex main-center cross-center">
        <span>认知</span>
      </div>
      <div class="list-title-primary as-flex main-center cross-center">
        <span>首选</span>
      </div>
    </div>
    <div class="list-content">
      <div class="list-list">
        <template v-for="(item) in movieList">
          <div
            v-if="item.id"
            :key="'movie_'+ item.id"
            @click="item.result.is_tracking?setMainMovie(item.id):commitRequirement(item)"
            class="movie-box-container"
          >
            <movieBox
              :movieInfo="item"
              :isLatest="latestOffset === item.result.offset"
              :isTracking="item.result.is_tracking"
              type="single"
            ></movieBox>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const offsetMapping = {
  /////kKkkdmfmgfmcv,cv,cmvmvdofsdjvdvXAZXDFRYJMIOL0P;LL
  "1.0": "映后一周",
  "0.0": "上映当周",
  "-1.0": "映前一周",
  "-2.0": "映前两周",
  "-3.0": "映前三周",
  "-4.0": "映前四周"
};
import { clone, sortBy } from "lodash";
import movieBox from "../components/index/movieBox.vue";
import indexChart from "../components/index/indexChart.vue";
import crowdpicker from "../components/index/crowdpicker.vue";
import surveyApi from "../api/surveyApi";
export default {
  name: "",
  props: {},
  components: {
    movieBox: movieBox,
    indexChart: indexChart,
    crowdpicker: crowdpicker
  },
  data() {
    return {
      surveyApi: new surveyApi(),
      isLoadingMovie: false,
      movieList: [],
      chartData: undefined,
      dateOptions: [],
      dateOptionsSelected: [],
      week_date_config: {
        current_week_index: undefined,
        current_year: undefined,
        weeks: []
      },
      crowd_config: {},
      current_crowd: ["overall", "overall"],
      next_week_date: {},
      last_week_date: {},
      update_date: undefined,

      offsetMapping: offsetMapping,
      latestOffset: undefined
    };
  },
  computed: {
    tabpageStatus: function() {
      return {
        dateOptionsSelected: this.dateOptionsSelected,
        current_crowd: this.current_crowd
      };
    },
    queryParams: function() {
      if (!this.dateOptionsSelected[1]) {
        return;
      }
      let res = this.parseDateString(this.dateOptionsSelected[1]);
      return {
        year: res.year,
        week: res.week,
        crowd: this.current_crowd[1]
      };
    }
  },
  methods: {
    parseDateString(dateString) {
      let reg = /([0-9]{4})年第([0-9]{1,2})周\(([0-9]{2}\/[0-9]{2})-([0-9]{2}\/[0-9]{2})\)上映/g;
      let reg_res = reg.exec(dateString);
      let res = {
        year: parseInt(reg_res[1]),
        date_begin: `${reg_res[1]}-${reg_res[3].replace(/\//g, "-")}`,
        date_end: `${reg_res[1]}-${reg_res[4].replace(/\//g, "-")}`,
        week: parseInt(reg_res[2])
      };
      return res;
    },
    stringifyDateObj(dateObj) {
      return `${dateObj.year}年第${dateObj.week}周(${dateObj.date_begin
        .slice(-5)
        .replace(/-/g, "/")}-${dateObj.date_end
        .slice(-5)
        .replace(/-/g, "/")})上映`;
    },
    handleDateChange(value) {},
    crowdUpdate(crowdArr) {
      this.current_crowd = crowdArr;
    },
    generateDateOptions(weeks) {
      let year = Object.entries(weeks).map(item => {
        return parseInt(item[0]);
      });
      year = sortBy(year);
      let res = year.map(item => {
        return {
          value: item,
          label: item,
          children: weeks[item].map(item => {
            return {
              value: this.stringifyDateObj(item),
              label: this.stringifyDateObj(item)
            };
          })
        };
      });
      return res;
    },
    changeweek(index) {
      if (index > 0) {
        this.dateOptionsSelected = [
          this.next_week_date.year,
          this.stringifyDateObj(this.next_week_date)
        ];
      } else {
        this.dateOptionsSelected = [
          this.last_week_date.year,
          this.stringifyDateObj(this.last_week_date)
        ];
      }
    },
    async initPageData() {
      await this.getMovieScheduler();
      await this.getCrowdTags();
      // this.movieList = await this.getLatestMovielist();
    },

    async getLatestMovielist(params) {
      let movieListRes = await this.$store.getters[
        "movie/getMovieApi"
      ].getMovieListByDate({
        year: params.year,
        week: params.week,
        crowd: this.current_crowd[1]
      });
      if (movieListRes.status === true) {
        this.update_date = movieListRes.data.update_date;
        if (movieListRes.data.movies[0]) {
          this.latestOffset = movieListRes.data.movies[0].result.offset;
        }
        return movieListRes.data;
      } else {
        return [];
        // throw new Error("查询电影列表失败");
      }
    },
    async getMovieScheduler() {
      let res = await this.$store.getters[
        "movie/getMovieApi"
      ].getMovieScheduler();
      if (res.status === true) {
        this.week_date_config.current_week_index = res.data.current_week_index;
        this.week_date_config.current_year = res.data.current_year;
        this.week_date_config.weeks = res.data.weeks;
        this.dateOptions = this.generateDateOptions(res.data.weeks);
      }
      //初始化日期选择器数据
      //设置初始日期选择器值
      if (
        this.dateOptionsSelected[0] === undefined &&
        this.dateOptionsSelected[1] === undefined
      ) {
        this.dateOptionsSelected = [
          this.week_date_config.current_year,
          this.stringifyDateObj({
            year: this.week_date_config.current_year,
            date_begin: this.week_date_config.weeks[
              this.week_date_config.current_year
            ][this.week_date_config.current_week_index].date_begin,
            date_end: this.week_date_config.weeks[
              this.week_date_config.current_year
            ][this.week_date_config.current_week_index].date_end,
            week: this.week_date_config.weeks[
              this.week_date_config.current_year
            ][this.week_date_config.current_week_index].week
          })
        ];
      }
    },
    async getCrowdTags() {
      let res = await this.surveyApi.getAllCrowdTags();
      if (res.status === true) {
        this.crowd_config = res.data;
      }
    },
    async getChartData(params) {
      let res = await this.$store.getters[
        "movie/getMovieApi"
      ].getMovieChartData(params);
      if (res.status === true) {
        return res.data;
      } else {
        return {};
      }
    },
    commitRequirement(data) {
      let mobile = this.$store.getters["user/getUserInfo"].mobile;
      let contact_mobile = this.$store.getters["user/getUserInfo"]
        .contact_mobile;
      let company = this.$store.getters["user/getUserInfo"].company;
      let movie = data.title;
      this.$requireModal({ mobile, company, movie, contact_mobile });
    },
    setMainMovie(id) {
      this.$store.commit("movie/setMainMovie", { id: id });
      this.$store.commit("movie/updateTotalMovieState");
      this.$router.push({
        path: "movies",
        query: { compaire_type: "single" }
      });
    },
    multiCompaire(movieArray = []) {
      //get movie_id in this cycle
      let movie_ids = this.movieList
        .filter(item => {
          return item.result.is_tracking;
        })
        .map(item => {
          return item.id;
        });
      this.$store.commit("movie/setCycleMoviesList", { list: movie_ids });
      this.$store.commit("movie/updateTotalMovieState");
      this.$router.push({
        path: "movies",
        query: { compaire_type: "cycle" }
      });
    },
    tabPageSetting() {
      let statusCode = this.$route.query.statusCode;
      if (statusCode) {
        //有statusCode,均是点击页签进入，根据statusCode从store中拿取数据，并且不再需要pushTab
        this.$store.commit("tabpage/setCurrentTabByStatusCode", {
          statusCode: statusCode
        });
        let tabpageInfo = this.$store.getters[
          "tabpage/getCurrentTabStatusInfo"
        ];
        this.initPageTabInfo(tabpageInfo);
        return;
      }
      this.$store.commit("tabpage/pushTab", {
        title: "每周档期",
        pathname: this.$route.name || "notfound",
        pathquery: Object.assign({}, this.$route.query),
        // pathparams: Object.assign({}, this.$route.params),
        type: "index",
        statusInfo: {
          mainMovie: undefined,
          movieList: undefined,
          filters: {}
        }
      });
    },
    initPageTabInfo(data) {
      //将filter中的数据映射回来
      Object.entries(data.filters).forEach(item => {
        if (this[item[0]] !== undefined) {
          this[item[0]] = item[1];
        }
      });
    }
  },
  watch: {
    tabpageStatus: {
      handler: function(to, from) {
        this.$store.commit("tabpage/updateCurrentTab", {
          statusInfo: {
            filters: clone(to)
          }
        });
      },
      deep: true
    },
    queryParams: {
      handler: async function(to, from) {
        //打开loading
        this.isLoadingMovie = true;
        try {
          //查询movielist
          // await Promise.all([this.getLatestMovielist(to),])
          let listData = await this.getLatestMovielist(clone(to));
          this.movieList = listData.movies || [];
          // this.last_week_date = listData.last_week;
          this.last_week_date = {
            year: listData.last_week.year,
            week: listData.last_week.week,
            date_begin: listData.last_week.begin,
            date_end: listData.last_week.end
          };
          // this.next_week_date = listData.next_week;
          this.next_week_date = {
            year: listData.next_week.year,
            week: listData.next_week.week,
            date_begin: listData.next_week.begin,
            date_end: listData.next_week.end
          };
          this.chartData = await this.getChartData(to);
          this.isLoadingMovie = false;
        } catch (e) {
          this.isLoadingMovie = false;
          throw new Error(e);
        }
      },
      deep: true
    },
    isLoadingMovie: function(to, from) {
      // if (to) {
      //   Indicator.open({
      //     text: "数据加载中",
      //     spinnerType: "fading-circle"
      //   });
      // } else {
      //   Indicator.close();
      // }
    }
  },
  created() {
    this.tabPageSetting();
    this.initPageData();
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.index-page {
  -webkit-overflow-scrolling: touch;
  background-color: #f9f9f9;
  // height: 100%;
  position: relative;
  overflow-y: scroll;
  padding: 0 20px;
}
.datepicker-content {
  height: 60px;
  padding: 10px 0;
  width: 100%;
  .datepicker-container {
    /deep/ .el-cascader__label {
      padding: 0 30px 0 15px;
    }
    /deep/ .el-input__inner {
      color: #666666;
      // font-size: 10px;
      height: 40px;
      background-color: #fff !important;
      min-width: 200px;
      border-radius: 4px;
      box-shadow: 0px 0px 4px 2px #f6f6f6;
    }
    /deep/ .el-input__suffix {
      background: url(../assets/images/data-selector.png);
      background-size: 80%;
      background-position: center;
      background-repeat: no-repeat;
      .el-icon-arrow-down {
        font-size: 0;
      }
    }
  }
  .last-week-arrow {
    width: 10px;
    height: 10px;
  }
  .datepicker {
    width: 270px;
  }
  .arrow {
    color: #aaaaaa;
    margin: 0 10px;
    &:hover {
      color: #61b6e6;
    }
  }
}
.data-caontainer {
  background-color: white;
}
.chart-content {
  width: 100%;
  height: 500px;
  background-color: #fff;
  padding: 10px 40px;
  .top-function-bar {
    width: 100%;
    height: 30px;
    .left-title {
      height: 100%;
      width: 200px;
    }
    .right-function {
      height: 100%;
      width: 600px;
      .crowd-picker {
        width: 500px;
        height: 100%;
        position: relative;
      }
      .multi-compaire {
        width: 100px;
        height: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        cursor: pointer;
        &:hover {
          color: #61b6e6;
        }
        .multi-compaire-btn {
          padding-left: 15px;
          border-left: 2px solid #eee;
        }
      }
    }
  }
  .chart-container {
    width: 100%;
    height: 450px;
    padding: 0px 10px;
    .chart-box {
      width: 48%;
      height: 420px;
      // background-color: burlywood;
      box-shadow: 0px 0px 4px 2px #eeeeee;
      &:hover {
        box-shadow: 0px 0px 6px 3px #eeeeee;
      }
      padding: 10px 30px;
      .chart-desc {
        width: 100%;
        height: 50px;
        border-bottom: 1px solid #eeeeee;
        padding: 10px 0;
        .question-tip-icon {
          margin: 0 5px;
        }
      }
      .index-chart {
        width: 100%;
        height: 350px;
      }
    }
  }
}
.list-title {
  height: 30px;
  width: 100%;
  background-color: #f8f8f8;
  padding: 0 40px;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 1;
  .list-title-movie {
    width: 50%;
    height: 100%;
  }
  .list-title-awareness {
    width: 25%;
    height: 100%;
  }
  .list-title-primary {
    width: 25%;
    height: 100%;
  }
}
.list-content {
  width: 100%;
  // height: calc(100% - 540px);
  .list-list {
    // height: calc(100% - 30px);
    width: 100%;
    background-color: #fff;
    padding: 0 40px;
    .movie-box-container {
      height: 150px;
      width: 100%;
      border-bottom: 1px solid #efefef;
    }
  }
}

input {
  outline: none;
  height: 0.62rem;
  width: 6.2rem;
  color: white;
  border: none;
  border-radius: 0.5rem;
  padding: 0.05rem 1rem;
  background-color: #f8f8f8;
}
input::hover {
  outline: none;
}

/deep/ .el-input__inner {
  background-color: #f8f8f8;
  border: none;
}
/deep/ .el-icon-arrow-down {
}
</style>


